var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative","margin":"0 auto","max-width":"unset","width":"calc(100 * var(--app-vw))"},attrs:{"id":"app"}},[_c('audio',{attrs:{"id":"clockSound","src":require('@/assets/music/clock.mp3'),"preload":"auto"}}),_vm._v(" "),_c('audio',{attrs:{"id":"niaoSound","src":require('@/assets/music/niao.mp3'),"preload":"auto"}}),_vm._v(" "),_c('audio',{attrs:{"id":"niao2Sound","src":require('@/assets/music/niao2.mp3'),"preload":"auto"}}),_vm._v(" "),(!_vm.palymusic)?_c('img',{style:({
      width: 'calc(8 * var(--app-vw))',
      position: 'absolute',
      right: 'calc(5 * var(--app-vw))',
      top: 'calc(5 * var(--app-vw))',
      zIndex: '999999',
    }),attrs:{"id":"audioimage","src":require('@/assets/images/nomusic.png')},on:{"click":_vm.audioPlayOrPause}}):_c('img',{style:({
      width: '8%',
      position: 'absolute',
      right: 'calc(5 * var(--app-vw))',
      top: 'calc(5 * var(--app-vw))',
      zIndex: '999999',
      animation: 'playframes 2s linear infinite',
    }),attrs:{"id":"audioimage","src":require('@/assets/images/music.png')},on:{"click":_vm.audioPlayOrPause}}),_vm._v(" "),_c('audio',{ref:"audio",attrs:{"id":"audioa","src":require('@/assets/music/music.mp3'),"loop":"","preload":"auto"},on:{"pause":_vm.onPause,"play":_vm.onPlay}}),_vm._v(" "),_c('keep-alive',[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a6d5adf","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 